import api from '@/features/api/axios';
import { logger } from '@/features/help/utils/logger';
import { getRecaptchaHeaders } from '@/features/application/utils/recaptcha-token.utils';

export interface DocumentUploadParams {
  userShortId: string;
  mappingShortId: string;
  crmId: string;
  files: File[];
}

export interface DocumentUploadResult {
  success: boolean;
  successCount: number;
  failureCount: number;
  results?: Array<{
    fileName: string;
    mimeType: string;
    status: 'success' | 'error';
    errorMessage?: string;
  }>;
}

// Purpose: Upload document-upload page files directly to the CRM record
export const uploadBankStatements = async ({
  userShortId,
  mappingShortId,
  crmId,
  files,
}: DocumentUploadParams): Promise<DocumentUploadResult> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });

  const url = `/api/record-actions/upload-bank-statements/${userShortId}/${mappingShortId}?crmId=${encodeURIComponent(
    crmId
  )}`;

  try {
    logger.info('DocumentUploadAPI', 'Starting bank statement upload to CRM', {
      userShortId,
      mappingShortId,
      crmId,
      fileCount: files.length,
    });

    const { data } = await api.post<DocumentUploadResult>(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(await getRecaptchaHeaders('upload_bank_statements')),
      },
    });

    logger.info('DocumentUploadAPI', 'Completed bank statement upload to CRM', {
      userShortId,
      mappingShortId,
      crmId,
      successCount: data.successCount,
      failureCount: data.failureCount,
    });

    return data;
  } catch (error) {
    logger.error('DocumentUploadAPI', 'Failed to upload bank statements to CRM', {
      userShortId,
      mappingShortId,
      crmId,
      error,
    });
    throw error;
  }
};


